import React from 'react'

const logo = require('../assets/dan-logo.png')

export default () => (
  <div>
    <div className="head">
      <div className="container">
        <img src={logo} alt="DAN EV - Dienst am Nächsten" className="logo" />
        <span
          id="global-slogan"
          data-editable="simpletext"
          className="slogan"
          data-global="data-global"
        >
          Nachbarschaftshilfe
          <br />
          von Mensch zu Mensch
        </span>
        <div className="hotline">
          <strong
            id="global-fragen"
            data-editable="simpletext"
            data-global="data-global"
          >
            Sie haben Fragen?
          </strong>
          <br />
          <span
            id="global-phone"
            data-editable="simpletext"
            data-global="data-global"
          >
            0174/3444893
            <br />
          </span>
        </div>
      </div>
    </div>
    <div className="nav">
      <div className="container">
        <ul className="clearfix">
          <li>
            <a href="/home">Startseite</a>
          </li>
          <li>
            <a href="/geschichte">Über Uns</a>
          </li>
          <li>
            <a href="/dienstleistungen">Dienstleistungen</a>
          </li>
          <li>
            <a href="/sie-wollen-helfen">Sie wollen helfen?</a>
          </li>
          <li className="active">
            <a href="/mitglieder" className="active">
              Mitglieder
            </a>
          </li>
          <li>
            <a href="/kontakt">Kontakt</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="content">
      <div className="container">
        <h1 id="mitglieder" data-editable="simpletext" className="mb1">
          Sie wollen Mitglied werden?
        </h1>
        <p id="content" data-editable="text">
          Mit der Mitgliedschaft unterstützen Sie unseren gemeinnützigen Verein.
          <br />
          <br />
          Wenn Sie Mitglied werden möchten, nehmen Sie gerne Kontakt auf unter:{' '}
          <a href="mailto:info@dan-ev.de">info@dan-ev.de</a>
        </p>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/mitglieder.js